module.exports = __webpack_public_path__ + "do.svg?34a43d3ce2bcc7c5fcf4388dde856271";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/do.svg
// module id = 1236
// module chunks = 27